/* eslint-disable react/no-danger */
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { Link } from "react-router-dom";
import api from "../api/api";
import HomeStyle from "../assets/css/home.module.css";
import SearchWidget from "../components/banner/SearchWidget";
import Loader from "../components/loader/Loader";
import { setLoading, setParks } from "../store/features/parkSlice";
import travelOptionIllustration from "../assets/images/travel-option.png";
import playStoreLogo from "../assets/images/google-play-store.png";
import appStoreLogo from "../assets/images/apple-app-store.png";
// import whatsAppLogo from "../assets/images/whats-app-button.png";
// import parkImage from "../assets/images/park.svg";

import busTicketIcon from "../assets/icons/bus-ticket-icon.svg";
import airTicketIcon from "../assets/icons/air-ticket-icon.svg";
import trainTicketIcon from "../assets/icons/train-ticket-icon.svg";
import launchTicketIcon from "../assets/icons/launch-ticket-icon.svg";
import eventTicketIcon from "../assets/icons/event-ticket-icon.svg";
import parkTicketIcon from "../assets/icons/park-ticket-icon.svg";
import ParkCard from "./ParkCard";
import AppConstants from "../constants/AppConstants";

export default function Index() {
  const [firstLoader, setFirstLoader] = useState(false);

  const dispatch = useDispatch();
  const [selectedFaqId, setSelectedFaqId] = useState(0);
  const { parks, loading } = useSelector((state) => state.parkSlice);
  const [filter] = useState({ name: "", address: "" });

  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [parkSuggestions, setParkSuggestions] = useState([]);
  const [filteredParks, setFilteredParks] = useState([]);

  const fetch = useCallback(async () => {
    if (!firstLoader) {
      dispatch(setLoading(true));
      const res = await api.parks(filter);
      if (res?.status === 200) {
        dispatch(setParks(res.data.data));
        setFirstLoader(true);
      }
      dispatch(setLoading(false));
    }
  }, [filter, firstLoader, dispatch]);

  function updateInputSuggesstionsData() {
    const locationSuggestionsVal = sessionStorage.getItem(AppConstants.SS_KEY.HANDSHAKE_DATA)
      ? JSON.parse(sessionStorage.getItem(AppConstants.SS_KEY.HANDSHAKE_DATA)).locations
      : [];

    const parkSuggestionsVal = [];
    const parkSuggestionsObjectArray = sessionStorage.getItem(AppConstants.SS_KEY.HANDSHAKE_DATA)
      ? JSON.parse(sessionStorage.getItem(AppConstants.SS_KEY.HANDSHAKE_DATA)).parks
      : [];
    parkSuggestionsObjectArray.forEach((element) =>
      parkSuggestionsVal.push(element.name)
    );

    setLocationSuggestions(locationSuggestionsVal);
    setParkSuggestions(parkSuggestionsVal);
  }

  const fetchHandshake = useCallback(async () => {
    const handShakeData = sessionStorage.getItem(AppConstants.SS_KEY.HANDSHAKE_DATA);
    if (!handShakeData) {
      const res = await api.handshake();
      if (res?.status === 200) {
        const handshakeRes = res?.data?.data;
        sessionStorage.setItem(AppConstants.SS_KEY.HANDSHAKE_DATA, JSON.stringify(handshakeRes));

        updateInputSuggesstionsData();
      }
    }
  }, []);

  useEffect(() => {
    setFilteredParks(parks);
  }, [parks]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  useEffect(() => {
    fetchHandshake();
  }, [fetchHandshake]);

  useEffect(() => {
    const handShakeData = sessionStorage.getItem(AppConstants.SS_KEY.HANDSHAKE_DATA);
    if (handShakeData) {
      updateInputSuggesstionsData();
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleFaq = (id) => {
    if (id === selectedFaqId) {
      setSelectedFaqId(0);
    } else {
      setSelectedFaqId(id);
    }
  };

  return (
    <>
      <SearchWidget
        locationSuggestions={locationSuggestions}
        parkSuggestions={parkSuggestions}
      />

      {/* Park List */}
      <section className={`${HomeStyle.park_list} ${HomeStyle.home_font}`}>
        <p className={HomeStyle.oss_head_1}>Feeling Bored</p>
        <p className={HomeStyle.oss_head_2}>Take a Break at an Amusement Park</p>

        <div className={HomeStyle.park_home_container}>
          <div className="row">
            {loading && (
              <div className="col-sm-12">
                <div className="pt-5 d-flex align-items-center justify-content-center">
                  <Loader />
                </div>
              </div>
            )}

            {!loading && filteredParks.length > 0 && (
              <>
                {filteredParks.map((park) => (
                  <div key={park.id}>
                    <ParkCard park={park} />
                  </div>
                ))}
              </>
            )}

            {!loading && filteredParks.length === 0 && (
              <span className={HomeStyle.no_park_found}>No park found.</span>
            )}
          </div>
        </div>
      </section>

      {/* Purchase Steps */}
      <section
        className={`${HomeStyle.ticket_purchase_steps} ${HomeStyle.home_font}`}
      >
        <div className={HomeStyle.park_home_container}>
          <div className={`${HomeStyle.purchase_step} row`}>
            <div className="col-md-12">
              <h3 className={HomeStyle.section_heading}>
                Buy tickets
                <span> in 3 easy steps</span>
              </h3>
            </div>
            <div className={`${HomeStyle.mb_4} col-sm-12 col-md-4`}>
              <div className="row">
                <div className="col-3 col-md-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="62"
                    height="79"
                    viewBox="0 0 62 79"
                    fill="none"
                  >
                    <rect
                      x="19"
                      y="15"
                      width="43"
                      height="64"
                      rx="12"
                      fill="#079D49"
                      fillOpacity="0.05"
                    />
                    <path
                      d="M24.65 3.85742C36.25 3.85742 45.65 13.2574 45.65 24.8574C45.65 36.4574 36.25 45.8574 24.65 45.8574C13.05 45.8574 3.65002 36.4574 3.65002 24.8574C3.65002 13.2574 13.15 3.85742 24.65 3.85742ZM24.65 0.857422C11.45 0.857422 0.650024 11.5574 0.650024 24.8574C0.650024 38.1574 11.35 48.8574 24.65 48.8574C37.95 48.8574 48.65 38.1574 48.65 24.8574C48.65 11.5574 37.95 0.857422 24.65 0.857422Z"
                      fill="#079D49"
                    />
                    <path
                      d="M52.75 61.4572C51.35 61.4572 49.95 60.9572 48.95 59.8572L35.85 46.7572C35.25 46.1572 35.25 45.2572 35.85 44.6572C36.45 44.0572 37.35 44.0572 37.95 44.6572L50.95 57.7572C51.85 58.6572 53.35 58.6572 54.25 57.8572C54.75 57.4572 55.05 56.7572 55.05 56.1572C55.05 55.4572 54.85 54.8572 54.35 54.4572L41.85 41.9572C41.25 41.3572 41.25 40.4572 41.85 39.8572C42.45 39.2572 43.35 39.2572 43.95 39.8572L56.55 52.2572C57.65 53.2572 58.15 54.6572 58.15 56.1572C58.15 57.6572 57.55 59.0572 56.45 60.0572C55.35 60.9572 54.05 61.4572 52.75 61.4572Z"
                      fill="#079D49"
                    />
                  </svg>
                </div>
                <div className="col-9 col-md-9">
                  <p className={HomeStyle.step_title}>Search</p>
                  <p className={HomeStyle.step_description}>
                    Browse rides or parks from our wide range of partners
                  </p>
                </div>
              </div>
            </div>
            <div className={`${HomeStyle.mb_4} col-sm-12 col-md-4`}>
              <div className="row">
                <div className="col-3 col-md-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="63"
                    height="87"
                    viewBox="0 0 63 87"
                    fill="none"
                  >
                    <path
                      d="M8.1499 24.2578H2.1499C1.3499 24.2578 0.649902 23.5578 0.649902 22.7578C0.649902 21.9578 1.3499 21.2578 2.1499 21.2578H8.1499C8.9499 21.2578 9.6499 21.9578 9.6499 22.7578C9.6499 23.5578 8.9499 24.2578 8.1499 24.2578Z"
                      fill="#079D49"
                    />
                    <path
                      d="M12.3499 14.1578C11.9499 14.1578 11.5499 14.0578 11.2499 13.7578L7.04985 9.55781C6.44985 8.95781 6.44985 8.05781 7.04985 7.45781C7.64985 6.85781 8.54985 6.85781 9.14985 7.45781L13.3499 11.6578C13.9499 12.2578 13.9499 13.1578 13.3499 13.7578C13.1499 14.0578 12.7499 14.1578 12.3499 14.1578Z"
                      fill="#079D49"
                    />
                    <path
                      d="M22.45 9.95742C21.65 9.95742 20.95 9.25742 20.95 8.45742V2.35742C20.95 1.55742 21.65 0.857422 22.45 0.857422C23.25 0.857422 23.95 1.55742 23.95 2.35742V8.45742C23.95 9.25742 23.25 9.95742 22.45 9.95742Z"
                      fill="#079D49"
                    />
                    <path
                      d="M32.8498 13.8572C32.4498 13.8572 32.0498 13.6572 31.7498 13.3572C31.1498 12.7572 31.1498 11.8572 31.7498 11.2572L35.8498 7.35723C36.4498 6.75723 37.3498 6.75723 37.9498 7.35723C38.5498 7.95723 38.5498 8.85723 37.9498 9.45723L33.8498 13.3572C33.5498 13.7572 33.2498 13.8572 32.8498 13.8572Z"
                      fill="#079D49"
                    />
                    <path
                      d="M42.7499 24.2578H36.45C35.65 24.2578 34.95 23.5578 34.95 22.7578C34.95 21.9578 35.65 21.2578 36.45 21.2578H42.7499C43.5499 21.2578 44.2499 21.9578 44.2499 22.7578C44.2499 23.5578 43.5499 24.2578 42.7499 24.2578Z"
                      fill="#079D49"
                    />
                    <path
                      d="M41.0498 68.5578H18.1498C17.0498 68.5578 15.9498 68.0578 15.2498 67.2578C14.4498 66.3578 11.9498 62.7578 8.94983 58.5578C6.24983 54.6578 3.04983 50.3578 2.24983 49.2578C1.54983 48.3578 1.14983 47.2578 1.24983 46.0578C1.34983 44.9578 1.94983 43.8578 2.84983 43.1578C6.04983 40.5578 10.4498 40.3578 13.8498 42.6578L15.5498 43.8578V22.1578C15.5498 18.3578 18.6498 15.2578 22.4498 15.2578C26.2498 15.2578 29.3498 18.3578 29.3498 22.1578V34.3578L39.9498 38.3578C45.7498 40.5578 49.1498 46.4578 48.0498 52.5578C47.1498 57.7578 45.4498 64.0578 44.4498 66.2578C43.9498 67.6578 42.5498 68.5578 41.0498 68.5578ZM8.64983 44.1578C7.24983 44.1578 5.84983 44.6578 4.64983 45.5578C4.34983 45.7578 4.24983 46.0578 4.14983 46.4578C4.04983 46.8578 4.24983 47.1578 4.44983 47.3578C5.44983 48.4578 8.24983 52.5578 11.3498 56.8578C14.0498 60.6578 16.8498 64.5578 17.4498 65.3578C17.6498 65.5578 17.8498 65.6578 18.0498 65.6578H41.0498C41.3498 65.6578 41.6498 65.4578 41.8498 65.1578C42.6498 63.3578 44.2498 57.6578 45.1498 52.1578C45.9498 47.5578 43.3498 42.9578 38.9498 41.3578L27.3498 36.9578C26.7498 36.7578 26.3498 36.1578 26.3498 35.5578V22.2578C26.3498 20.0578 24.5498 18.3578 22.4498 18.3578C20.2498 18.3578 18.5498 20.1578 18.5498 22.2578V46.6578C18.5498 47.2578 18.2498 47.7578 17.7498 47.9578C17.2498 48.2578 16.6498 48.1578 16.2498 47.8578L12.1498 45.2578C11.0498 44.4578 9.84983 44.1578 8.64983 44.1578Z"
                      fill="#079D49"
                    />
                    <rect
                      x="20"
                      y="23"
                      width="43"
                      height="64"
                      rx="12"
                      fill="#079D49"
                      fillOpacity="0.05"
                    />
                    <path
                      d="M27.9497 43.158C27.1497 43.158 26.4497 42.458 26.4497 41.658V35.458C26.4497 34.658 27.1497 33.958 27.9497 33.958C28.7497 33.958 29.4497 34.658 29.4497 35.458V41.658C29.4497 42.458 28.7497 43.158 27.9497 43.158Z"
                      fill="#079D49"
                    />
                  </svg>
                </div>
                <div className="col-9 col-md-9">
                  <p className={HomeStyle.step_title}>Select</p>
                  <p className={HomeStyle.step_description}>
                    Choose the tickets from the park you want to visit
                  </p>
                </div>
              </div>
            </div>
            <div className={`${HomeStyle.mb_4} col-sm-12 col-md-4`}>
              <div className="row">
                <div className="col-3 col-md-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="62"
                    height="77"
                    viewBox="0 0 62 77"
                    fill="none"
                  >
                    <path
                      d="M27.5499 0.257812H22.6499H13.8499H8.9499C4.3499 0.257812 0.649902 3.95781 0.649902 8.55781V50.4578C0.649902 55.0578 4.3499 58.7578 8.9499 58.7578H27.4499C32.0499 58.7578 35.7499 55.0578 35.7499 50.4578V8.55781C35.9499 3.95781 32.1499 0.257812 27.5499 0.257812ZM32.9499 50.4578C32.9499 53.3578 30.5499 55.7578 27.6499 55.7578H9.0499C6.1499 55.7578 3.7499 53.3578 3.7499 50.4578V8.55781C3.7499 5.65781 6.1499 3.25781 9.0499 3.25781H12.4499V4.75781C12.4499 5.55781 13.1499 6.25781 13.9499 6.25781H22.7499C23.5499 6.25781 24.2499 5.55781 24.2499 4.75781V3.25781H27.6499C30.5499 3.25781 32.9499 5.65781 32.9499 8.55781V50.4578Z"
                      fill="#079D49"
                    />
                    <rect
                      x="19"
                      y="13"
                      width="43"
                      height="64"
                      rx="12"
                      fill="#079D49"
                      fillOpacity="0.05"
                    />
                    <path
                      d="M24.1498 32.5582C23.4498 32.0582 22.5498 32.1582 22.0498 32.8582C21.5498 33.5582 21.6498 34.4582 22.3498 34.9582C23.5498 35.8582 23.9498 36.5582 23.9498 37.6582C23.9498 39.0582 22.5498 40.1582 20.8498 40.1582C19.1498 40.1582 17.8498 38.9582 17.8498 37.5582V29.8582H23.1498C23.9498 29.8582 24.6498 29.1582 24.6498 28.3582C24.6498 27.5582 23.9498 26.8582 23.1498 26.8582H17.8498V23.4582C17.8498 22.2582 17.2498 21.1582 16.2498 20.4582C15.1498 19.6582 13.6498 19.4582 12.3498 19.8582L11.0498 20.2582C10.2498 20.5582 9.84981 21.3582 10.1498 22.1582C10.4498 22.9582 11.2498 23.3582 12.0498 23.0582L13.3498 22.6582C13.8498 22.4582 14.2498 22.6582 14.5498 22.8582C14.6498 22.9582 14.8498 23.1582 14.8498 23.3582V26.7582H11.0498C10.2498 26.7582 9.5498 27.4582 9.5498 28.2582C9.5498 29.0582 10.2498 29.7582 11.0498 29.7582H14.8498V37.4582C14.8498 40.4582 17.5498 42.9582 20.9498 42.9582C24.3498 42.9582 27.0498 40.4582 27.0498 37.4582C26.9498 34.9582 25.3498 33.4582 24.1498 32.5582Z"
                      fill="#079D49"
                    />
                  </svg>
                </div>
                <div className="col-9 col-md-9">
                  <p className={HomeStyle.step_title}>Pay</p>
                  <p className={HomeStyle.step_description}>
                    Complete payment and get your tickets without standing in
                    lines
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* One Stop Solution */}
      <section
        className={`${HomeStyle.one_stop_solution} ${HomeStyle.home_font}`}
      >
        <p className={HomeStyle.oss_head_1}>Your All-in-One Travel Solution</p>
        <p className={HomeStyle.oss_head_2}>
          Discover the Shohoz Experience for Seamless Journeys
        </p>

        <div className={HomeStyle.park_home_container}>
          <div className="row">
            {/* Bus */}
            <div className="col-sm-6 col-md-4">
              <div className={HomeStyle.service_item_icon_wrap}>
                <img
                  src={busTicketIcon}
                  alt="Bus Ticket Icon"
                  width={81}
                  height={80}
                />
              </div>

              <p className={HomeStyle.solution_title}>
                Bus <span>Ticket</span>
              </p>
              <p className={HomeStyle.solution_info}>
                Skip the queues with Shohoz! Book bus tickets online with access
                to 100+ operators nationwide. Easily browse routes, compare
                prices, and secure your seat in just a few clicks. Enjoy
                hassle-free travel with Shohoz&apos;s reliable bus ticketing
                service.
              </p>
            </div>

            {/* Air */}
            <div className="col-sm-6 col-md-4">
              <div className={HomeStyle.service_item_icon_wrap}>
                <img
                  src={airTicketIcon}
                  alt="Air Ticket Icon"
                  width={81}
                  height={80}
                />
              </div>

              <p className={HomeStyle.solution_title}>
                Air <span>Ticket</span>
              </p>
              <p className={HomeStyle.solution_info}>
                Fly with ease using Shohoz! Search and book domestic and
                international flights online. Compare prices, secure the best
                deals, and enjoy a smooth booking process with Shohoz, your
                go-to platform for all air travel needs.{" "}
              </p>
            </div>

            {/* Train */}
            <div className="col-sm-6 col-md-4">
              <div className={HomeStyle.service_item_icon_wrap}>
                <img
                  src={trainTicketIcon}
                  alt="Train Ticket Icon"
                  width={81}
                  height={80}
                />
              </div>

              <p className={HomeStyle.solution_title}>
                Train <span>Ticket</span>
              </p>
              <p className={HomeStyle.solution_info}>
                Book train tickets effortlessly with Shohoz! Access 100% of
                Bangladesh Railway&apos;s tickets online, check routes and
                schedules, and secure your seat from the comfort of home. Enjoy
                a hassle-free booking experience with Shohoz.
              </p>
            </div>

            {/* Launch */}
            <div className="col-sm-6 col-md-4">
              <div className={HomeStyle.service_item_icon_wrap}>
                <img
                  src={launchTicketIcon}
                  alt="Launch Ticket Icon"
                  width={81}
                  height={80}
                />
              </div>

              <p className={HomeStyle.solution_title}>
                Launch <span>Ticket</span>
              </p>
              <p className={HomeStyle.solution_info}>
                Book launch or ship tickets effortlessly with Shohoz! Explore
                routes, check availability, and reserve your booking online
                among a wide range of trusted operators. Enjoy a smooth and
                convenient booking experience for your waterway journeys.
              </p>
            </div>

            {/* Event */}
            <div className="col-sm-6 col-md-4">
              <div className={HomeStyle.service_item_icon_wrap}>
                <img
                  src={eventTicketIcon}
                  alt="Event Ticket Icon"
                  width={81}
                  height={80}
                />
              </div>

              <p className={HomeStyle.solution_title}>
                Event <span>Ticket</span>
              </p>
              <p className={HomeStyle.solution_info}>
                Get event tickets quickly with Shohoz! From concerts to
                seminars, browse a variety of events and book your tickets
                online with ease. Skip the long lines, waiting under the heat
                and enjoy a seamless booking experience for all your event
              </p>
            </div>

            {/* Park */}
            <div className="col-sm-6 col-md-4">
              <div className={HomeStyle.service_item_icon_wrap}>
                <img
                  src={parkTicketIcon}
                  alt="Park Ticket Icon"
                  width={81}
                  height={80}
                />
              </div>

              <p className={HomeStyle.solution_title}>
                Park <span>Ticket</span>
              </p>
              <p className={HomeStyle.solution_info}>
                Skip the lines and dive into fun with Shohoz! Purchase park
                tickets online for amusement parks, water parks, and more. Enjoy
                a smooth booking process and get ready for a day of adventure
                with Shohoz.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile Apps */}
      <section className={`${HomeStyle.mobile_app} ${HomeStyle.home_font}`}>
        <div className={HomeStyle.park_home_container}>
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <img
                alt="Mobile app illustration"

                loading="lazy"
                src="https://s3-ap-south-1.amazonaws.com/shohoz-bus/prod/app-illustration-v2.webp?v=1.0.3"
                className={HomeStyle.mobile_app_illustration}
              />
            </div>

            <div className={`${HomeStyle.vertical_center_of_div} col-sm-12 col-md-6`}>
              <div className={HomeStyle.mobile_app_benefits_container}>
                <p className={HomeStyle.mobile_app_benefit_title}>
                  Get More Out of Shohoz with our <span>mobile app</span>
                </p>

                <div className={HomeStyle.mobile_app_benefits}>
                  <div className={HomeStyle.single_benefit}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="21"
                        height="21"
                        rx="10.5"
                        fill="white"
                        stroke="#EEEEEE"
                      />
                      <path
                        d="M13.5001 11.0003L9.96422 14.5361L8.78589 13.357L11.1434 11.0003L8.78589 8.64363L9.96422 7.46447L13.5001 11.0003Z"
                        fill="#16D378"
                      />
                    </svg>
                    <p className={HomeStyle.benefit_text}>
                      Faster and easier booking
                    </p>
                  </div>

                  <div className={HomeStyle.single_benefit}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="21"
                        height="21"
                        rx="10.5"
                        fill="white"
                        stroke="#EEEEEE"
                      />
                      <path
                        d="M13.5001 11.0003L9.96422 14.5361L8.78589 13.357L11.1434 11.0003L8.78589 8.64363L9.96422 7.46447L13.5001 11.0003Z"
                        fill="#16D378"
                      />
                    </svg>
                    <p className={HomeStyle.benefit_text}>
                      Get alerts before every departure
                    </p>
                  </div>

                  <div className={HomeStyle.single_benefit}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="21"
                        height="21"
                        rx="10.5"
                        fill="white"
                        stroke="#EEEEEE"
                      />
                      <path
                        d="M13.5001 11.0003L9.96422 14.5361L8.78589 13.357L11.1434 11.0003L8.78589 8.64363L9.96422 7.46447L13.5001 11.0003Z"
                        fill="#16D378"
                      />
                    </svg>
                    <p className={HomeStyle.benefit_text}>
                      Easy access to your tickets
                    </p>
                  </div>

                  <div className={HomeStyle.single_benefit}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="21"
                        height="21"
                        rx="10.5"
                        fill="white"
                        stroke="#EEEEEE"
                      />
                      <path
                        d="M13.5001 11.0003L9.96422 14.5361L8.78589 13.357L11.1434 11.0003L8.78589 8.64363L9.96422 7.46447L13.5001 11.0003Z"
                        fill="#16D378"
                      />
                    </svg>
                    <p className={HomeStyle.benefit_text}>
                      Onboard with digital tickets
                    </p>
                  </div>
                </div>

                <div className={HomeStyle.app_store_links}>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.shohoz.rides"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      alt="google-play-store"
                      className={HomeStyle.play_store_logo}
                      src={playStoreLogo}
                    />
                  </a>
                  <a
                    href="https://apps.apple.com/us/app/shohoz-app/id1354321445?ls=1"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      alt="apple-app-store"
                      className={HomeStyle.app_store_logo}
                      src={appStoreLogo}
                    />
                  </a>
                  {/* <a
                    href="https://wa.me/8801999916374?text=Hi"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      alt="whats-app-text"
                      className={HomeStyle.app_store_logo}
                      src={whatsAppLogo}
                    />
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Travel Options */}
      <section className={`${HomeStyle.travel_options} ${HomeStyle.home_font}`}>
        <div className={HomeStyle.park_home_container}>
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <p className={HomeStyle.travel_option_title}>
                All your <span>travel options</span> in one place
              </p>
              <p className={HomeStyle.travel_option_description}>
                More than 1,000 trusted travel partners across trains, buses,
                flights, and launch so that you can focus on the journey.
              </p>
              <div className={HomeStyle.travel_option_counter}>
                <div className="d-flex flex-column justify-content-between px-2">
                  <p className={HomeStyle.travel_option_amount}>250 Million+</p>
                  <p className={HomeStyle.travel_option_label}>Tickets Sold</p>
                </div>
                <div className="flex flex-column justify-content-between px-2">
                  <p className={HomeStyle.travel_option_amount}>3000+</p>
                  <p className={HomeStyle.travel_option_label}>Routes</p>
                </div>
                <div className="flex flex-column justify-content-between px-2">
                  <p className={HomeStyle.travel_option_amount}>10 Million+</p>
                  <p className={HomeStyle.travel_option_label}>Happy Users</p>
                </div>
              </div>
            </div>
            <div
              className={`col-sm-12 col-md-6 ${HomeStyle.travel_option_illustration_col}`}
            >
              <img
                alt="travel option"
                className={HomeStyle.travel_option_illustration}
                width="393"
                height="310"
                src={travelOptionIllustration}
              />
            </div>
          </div>
        </div>
      </section>

            {/* Frequent Asked Questions */}
            { typeof SuperAppJsChannel === "undefined" && <section className={`${HomeStyle.faq_wrapper} ${HomeStyle.home_font}`}>
                <div className={HomeStyle.park_home_container}>
                    <div className="row">
                        <div className="col-sm-12 col-md-4">
                        <div className={HomeStyle.faq_left_section}>
                              <p className={HomeStyle.faq_title}>Got Questions ?</p>
                              <p className={HomeStyle.faq_subtitle}>We&apos;ve Got Answers</p>
                              <p className={HomeStyle.faq_info}>We are always happy to hear from you. If you have any questions, suggestions or opinions, please do not hesitate to reach out to us.</p>
                              <a className={HomeStyle.faq_contact_link} href="/contact-us">Contact Us</a>
                        </div>
                        </div>
                        <div className="col-sm-12 col-md-8">
                        <div className={HomeStyle.faq_single}>
                              <div className={HomeStyle.faq_single_title}>
                                    <h2 className={HomeStyle.faq_single_head}>How can I purchase a ticket from Shohoz Platform?</h2>
                                    <div className={HomeStyle.faq_single_collapse_btn_wrap}>
                                    <button
                                          type="button"
                                          aria-label="Faq Collapse and Extend Button"
                                          className={HomeStyle.faq_single_collapse_btn}
                                          onClick={() => toggleFaq(1)}
                                    >
                                          {selectedFaqId !== 1 &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                                </svg>
                                          }

                                          {selectedFaqId === 1 &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-usb-c" viewBox="0 0 16 16">
                                                <path d="M3.5 7.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"/>
                                                </svg>
                                          }
                                    </button>
                                    </div>
                              </div>
                              <div className={`${HomeStyle.faq_single_content} ${selectedFaqId !== 1 ? 'd-none' : ''}`}>
                                    <p className={HomeStyle.faq_single_content_text}>Please visit our website <a href="https://www.shohoz.com" className="fw-bold text-white">www.shohoz.com</a> or download our mobile App. <br/><a href="https://play.google.com/store/search?q=shohoz&amp;c=apps" target="_blank" rel="noreferrer" className="fw-bold text-white">Download App For Android</a><br/><a href="https://apps.apple.com/us/app/shohoz-app/id1354321445" target="_blank" rel="noreferrer" className="fw-bold text-white">Download App For IOS</a><br/>Or call our helpline number at <a href="tel:16374" className="fw-bold text-white">16374</a> for ticket purchase and for more information.</p>
                              </div>
                        </div>

                        <div className={HomeStyle.faq_single}>
                              <div className={HomeStyle.faq_single_title}>
                                    <h2 className={HomeStyle.faq_single_head}>Is there any time frame to buy a ticket?</h2>
                                    <div className={HomeStyle.faq_single_collapse_btn_wrap}>
                                    <button
                                          type="button"
                                          aria-label="Faq Collapse and Extend Button"
                                          className={HomeStyle.faq_single_collapse_btn}
                                          onClick={() => toggleFaq(2)}
                                    >
                                          {selectedFaqId !== 2 &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                                </svg>
                                          }

                                          {selectedFaqId === 2 &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-usb-c" viewBox="0 0 16 16">
                                                <path d="M3.5 7.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"/>
                                                </svg>
                                          }
                                    </button>
                                    </div>
                              </div>
                              <div className={`${HomeStyle.faq_single_content} ${selectedFaqId !== 2 ? 'd-none' : ''}`}>
                                    <p className={HomeStyle.faq_single_content_text}>There is no time limit to buy tickets from our website or app. But if a customer wants to purchase a ticket through our helpline number, then the customer should call our helpline number <a href="tel:16374" className="fw-bold text-white">16374</a> <b>(Operation Time- 7:00 AM to 11:00 PM)</b>.</p>
                              </div>
                        </div>

                        <div className={HomeStyle.faq_single}>
                              <div className={HomeStyle.faq_single_title}>
                                    <h2 className={HomeStyle.faq_single_head}>What is the process of Migrate or Cancelling a ticket?</h2>
                                    <div className={HomeStyle.faq_single_collapse_btn_wrap}>
                                    <button
                                          type="button"
                                          aria-label="Faq Collapse and Extend Button"
                                          className={HomeStyle.faq_single_collapse_btn}
                                          onClick={() => toggleFaq(3)}
                                    >
                                          {selectedFaqId !== 3 &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                                </svg>
                                          }

                                          {selectedFaqId === 3 &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-usb-c" viewBox="0 0 16 16">
                                                <path d="M3.5 7.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"/>
                                                </svg>
                                          }
                                    </button>
                                    </div>
                              </div>
                              <div className={`${HomeStyle.faq_single_content} ${selectedFaqId !== 3 ? 'd-none' : ''}`}>
                                    <p className={HomeStyle.faq_single_content_text}>For cancellation and migration, customers must have 12/24 hours before trip departure time depending on the operator. For migration, customers must call our helpline number <a href="tel:16374" className="fw-bold text-white">16374</a>. Also, the customer must call from his ticket booking number. Also, a customer can cancel a ticket from our website if he has enough time from the trip departure time (12/24 hours excluding 11 PM to 7 AM).</p>
                              </div>
                        </div>

                        <div className={HomeStyle.faq_single}>
                              <div className={HomeStyle.faq_single_title}>
                                    <h2 className={HomeStyle.faq_single_head}>How can I check Shohoz&apos;s offers?</h2>
                                    <div className={HomeStyle.faq_single_collapse_btn_wrap}>
                                    <button
                                          type="button"
                                          aria-label="Faq Collapse and Extend Button"
                                          className={HomeStyle.faq_single_collapse_btn}
                                          onClick={() => toggleFaq(4)}
                                    >
                                          {selectedFaqId !== 4 &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                                </svg>
                                          }

                                          {selectedFaqId === 4 &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-usb-c" viewBox="0 0 16 16">
                                                <path d="M3.5 7.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"/>
                                                </svg>
                                          }
                                    </button>
                                    </div>
                              </div>
                              <div className={`${HomeStyle.faq_single_content} ${selectedFaqId !== 4 ? 'd-none' : ''}`}>
                                    <p className={HomeStyle.faq_single_content_text}>Customers can check our offers on our website. Firstly, go to our website then Click &apos;BUS&apos; option, and then go to the &apos;<a href="/deals-and-offers" target="_blank" rel="noreferrer" className="fw-bold text-white">Deals and offers</a>&apos; option. Customers also can call our helpline number <a href="tel:16374" className="fw-bold text-white">16374</a> for more queries and offers.</p>
                              </div>
                        </div>

                        <div className={HomeStyle.faq_single}>
                              <div className={HomeStyle.faq_single_title}>
                                    <h2 className={HomeStyle.faq_single_head}>After purchasing a ticket from Shohoz, I cancelled that ticket due to a personal issue or the operator cancelled their trip. But I have not received my refund yet. What should I do now?</h2>
                                    <div className={HomeStyle.faq_single_collapse_btn_wrap}>
                                    <button
                                          type="button"
                                          aria-label="Faq Collapse and Extend Button"
                                          className={HomeStyle.faq_single_collapse_btn}
                                          onClick={() => toggleFaq(5)}
                                    >
                                          {selectedFaqId !== 5 &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                                </svg>
                                          }

                                          {selectedFaqId === 5 &&
                                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-usb-c" viewBox="0 0 16 16">
                                                <path d="M3.5 7.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1z"/>
                                                </svg>
                                          }
                                    </button>
                                    </div>
                              </div>
                              <div className={`${HomeStyle.faq_single_content} ${selectedFaqId !== 5 ? 'd-none' : ''}`}>
                                    <p className={HomeStyle.faq_single_content_text}>As per our <a href="/cancellation-and-refunds" target="_blank" rel="noreferrer" className="fw-bold text-white">refund policy</a>, it takes maximum of 5-7 working days for Bkash and Nagad both. For Internet banking, Debit cards and Credit cards it takes maximum of 7-10 working days. If the customer did not get the refund in mentioned timeline, please call <a href="tel:16374" className="fw-bold text-white">16374</a> or mail us at <a href="mailto:info@shohoz.com" className="fw-bold text-white">info@shohoz.com</a>.</p>
                              </div>
                        </div>
                        </div>
                  </div>
            </div>
            </section>
            }
        </>
    );
}
